import { Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import AcquisitionBanner from 'components/AcquisitionBanner/AcquisitionBanner'
import CompanyList from 'components/Insights/Company/CompanyList'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'

const Trends = () => {
  const isMobile = useCheckMobileScreen()

  return (
    <Stack
      sx={{
        background: isMobile ? COLORS.GRAY_8 : 'transparent',
        height: isMobile ? '100vh' : 'auto',
      }}>
      {!isMobile && (
        <Stack
          py="40px"
          pl="41px"
          sx={{
            backgroundColor: COLORS.PURE_WHITE,
            borderBottom: `1px solid ${COLORS.GRAY_5}`,
          }}>
          <Typography variant="h4">Trends</Typography>
        </Stack>
      )}

      <Stack mb={4}>
        <AcquisitionBanner />
      </Stack>

      <Stack
        sx={{
          px: isMobile ? '16px' : '41px',
          pt: isMobile ? '16px' : '0px',
          maxWidth: isMobile ? 'inherit' : '100%',
        }}>
        <CompanyList />
      </Stack>
    </Stack>
  )
}

export default Trends
